/**
 * @generated SignedSource<<e84213c2325dda84c87bfdc9dfff3432>>
 * @relayHash 1d82c4c6fd62dc3229962776694d890d
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1d82c4c6fd62dc3229962776694d890d

import type { ConcreteRequest } from 'relay-runtime';
export type IssuesAndPullRequestsCountSecondaryQuery$variables = {
  nodes: ReadonlyArray<string>;
};
export type IssuesAndPullRequestsCountSecondaryQuery$data = {
  readonly nodes: ReadonlyArray<{
    readonly id: string;
    readonly issueCount?: number | null | undefined;
    readonly pullRequestCount?: number | null | undefined;
  } | null | undefined>;
};
export type IssuesAndPullRequestsCountSecondaryQuery = {
  response: IssuesAndPullRequestsCountSecondaryQuery$data;
  variables: IssuesAndPullRequestsCountSecondaryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nodes"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "ids",
    "variableName": "nodes"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "issueCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pullRequestCount",
      "storageKey": null
    }
  ],
  "type": "Label",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IssuesAndPullRequestsCountSecondaryQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IssuesAndPullRequestsCountSecondaryQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "1d82c4c6fd62dc3229962776694d890d",
    "metadata": {},
    "name": "IssuesAndPullRequestsCountSecondaryQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0d4a78121c24775e76cc5d2986e632b7";

export default node;
